import Axios from "axios";
import {
  BaseApiRoutes,
  BaseApiGetters,
  ApiAsyncHelper,
} from "@/modules/core/classes/Api";

import { ActivityCategory } from "@/modules/activities/viewmodels/ActivityCategory";

export const state = {
  activityCategories: [],
};

export const getters = Object.assign(
  {
    activityCategories: (state) => {
      return state.activityCategories;
    },
  },
  new BaseApiGetters(
    process.env.VUE_APP_BASE_URL + "/api/activity-categories",
    ActivityCategory,
    {
      AfterGetAll: (name, data) => {
        data.forEach((e) => {
          let foundElement = state.activityCategories.find((ac) => ac.id === e);
          if (foundElement) {
            Object.assign(foundElement, e);
          } else {
            state.activityCategories.push(e);
          }
        });
        return data;
      },
    },
    {
      /**
       * Custom getters
       */
    }
  )
);

// mutations
export const mutations = {};

const httpAxios = Axios.create({
  baseURL:
    process.env.VUE_APP_BASE_URL &&
    process.env.VUE_APP_BASE_URL !== "" &&
    process.env.VUE_APP_BASE_URL !== null
      ? process.env.VUE_APP_BASE_URL
      : "http://localhost:8888",
});

export const actions = new BaseApiRoutes(
  process.env.VUE_APP_BASE_URL + "/api/activity-categories",
  [],
  {}
);
